export const baseURL = "http://kallo.chat:5005/";
export const secretKey = "5TIvw5cpc0";
export const projectName = "Kallo"
